(async () => (
  await import(/* webpackChunkName: "bootstrap" */ './bootstrap')
))();
